import React, { useState } from "react";
import { Lock } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminAuth = ({ isOpen, onClose, onAuthenticated }) => {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      
      if (response.data.access_token) {
        localStorage.setItem("tika_admin_token", response.data.access_token);
        localStorage.setItem("tika_admin_auth", "true");
        toast.success("Connexion réussie !");
        onAuthenticated();
      }
    } catch (error) {
      console.error("Erreur de connexion:", error);
      toast.error("Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-2xl">
            <Lock className="w-6 h-6 text-primary" />
            Administration
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="username">Nom d'utilisateur</Label>
            <Input
              data-testid="admin-username-input"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleInputChange}
              placeholder="admin"
              required
              className="mt-2"
            />
          </div>

          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input
              data-testid="admin-password-input"
              id="password"
              name="password"
              type="password"
              value={credentials.password}
              onChange={handleInputChange}
              placeholder="••••••••"
              required
              className="mt-2"
            />
          </div>

          <Button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-primary hover:bg-primary/90"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>

        <p className="text-xs text-muted-foreground text-center mt-4">
          Accès réservé aux administrateurs
        </p>
      </DialogContent>
    </Dialog>
  );
};
